/**
 * Interfaccia/classe LavoratoreRecord
 * Rappresenta la "coppia" lavoratore/contratto, fornendo le informazioni di base del lavoratore (cognome/nome) e del contratto (dt assunzione/cessazione, qualifica, livello, etc.)
 * La chiave primaria è rappresentata da <id> (vedi LavoratoreBase)
 */
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {DateTime} from "luxon";
import {FPNetDate, ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export interface LavoratoreRecord extends LavoratoreBase, URIAndTrace {
    codDip: number | null,
    codDipPaghe: number | null,
    dataAssunzione: FPNetDate,
    dataAssConvenzionale: FPNetDate,
    dataFineTDET: FPNetDate,
    dataCessazione: FPNetDate,
    qualifica: string | null,
    livello: string | null,
    codCDIC: string | null,
    partitaIvaPromotore: string | null,
    denominazionePromotore: string | null,
    codContrattoUNILAV: string | null,
    codTipologiaContratto: string | null,
    codTipologiaOrario: string | null,
    sesso: string | null,
}

export class LavoratoreRecord {
    static factory: ObjectFactory<LavoratoreRecord> = (json?) => {
        return merge<LavoratoreRecord, Partial<LavoratoreRecord> | undefined>({
            idAziendaMaster: 0,
            idAzienda: 0,
            id: 0,
            cognome: null,
            nome: null,
            descrizione: null,
            codiceFiscale: '',
            codDip: null,
            codDipPaghe: null,
            matricola: null,
            countXUL: null,
            dataAssunzione: null,
            dataAssConvenzionale: null,
            dataFineTDET: null,
            dataCessazione: null,
            codCDIC: null,
            qualifica: null,
            livello: null,
            partitaIvaPromotore: null,
            denominazionePromotore: null,
            codContrattoUNILAV: null,
            codTipologiaContratto: null,
            codTipologiaOrario: null,
            sesso: null,
            URI: null,
        }, json);
    };

    static isFired = (contratto: LavoratoreRecord, dtRiferimento: DateTime = DateTime.now()): boolean => {
        if (!contratto)
            throw new Error("contratto è null!");
        if (!contratto.dataCessazione ||
            DateTime.fromISO(contratto.dataCessazione).startOf("day") > dtRiferimento.startOf("day")
        ) {
            return false;
        } else {
            return true;
        }
    };

    static isHired = (contratto: LavoratoreRecord | null, dtGiornata: FPNetDate) => {
        if (contratto && (dtGiornata && contratto.dataAssunzione)) {
            const dataAssunzioneNew = DateTime.fromISO(contratto.dataAssunzione).toMillis();
            const dtGiornataNew = DateTime.fromISO(dtGiornata).toMillis();
            return (dataAssunzioneNew <= dtGiornataNew);
        } else {
            return false;
        }
    };


    static hasMoreUL = (lavoratore: LavoratoreRecord): boolean => {
        return lavoratore.countXUL ? lavoratore.countXUL > 1 : false;
    }
}